// Static demo data for Interactive FAQ
// Each question: duration (sec) is how long it stays "live"
// waitGap (sec) is the wait time shown before the NEXT question goes live

const faqData = [
  {
    id: 1,
    sequence: 1,
    totalQuestions: 4,
    question: "Which soft tissue structure is most commonly released last as a resort during correction in total knee replacement?",
    duration: 60,
    waitGap: 8,
    options: [
      { value: "opt1", label: "Iliotibial band" },
      { value: "opt2", label: "Popliteus tendon" },
      { value: "opt3", label: "Lateral collateral ligament" },
      { value: "opt4", label: "Lateral capsule" },
    ],
  },
  {
    id: 2,
    sequence: 2,
    totalQuestions: 4,
    question: "What is the underlying pathological cause of this radiographic appearance?",
    duration: 60,
    waitGap: 8,
    options: [
      { value: "opt1", label: "New bone formation by tumor cells along blood vessels" },
      { value: "opt2", label: "Rapid cartilage calcification" },
      { value: "opt3", label: "Infection and pus under the periosteum" },
      { value: "opt4", label: "Fibrous tissue replacement" },
    ],
  },
  {
    id: 3,
    sequence: 3,
    totalQuestions: 4,
    question: "What does 'OTP' stand for?",
    duration: 60,
    waitGap: 8,
    options: [
      { value: "opt1", label: "One Time Password" },
      { value: "opt2", label: "Online Ticket Process" },
      { value: "opt3", label: "Open Task Panel" },
      { value: "opt4", label: "Order Tracking Portal" },
    ],
  },
  {
    id: 4,
    sequence: 4,
    totalQuestions: 4,
    question: "Which module handles onsite check-in?",
    duration: 60,
    waitGap: 8,
    options: [
      { value: "opt1", label: "Onsite App" },
      { value: "opt2", label: "Feedback Module" },
      { value: "opt3", label: "Certificate Module" },
      { value: "opt4", label: "Membership Module" },
    ],
  },
];

export default faqData;
